module.exports = __webpack_public_path__ + "static/img/liveProperty.4cc8d52f.png";